// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.table-head-cell {
  position: relative;
  vertical-align: bottom;
  font-weight: 600;
  font-family: 'IBM Plex Sans';
  line-height: inherit;
}
.table-head-cell--align-left {
  text-align: left;
}
.table-head-cell--align-center {
  text-align: center;
}
.table-head-cell--align-right {
  text-align: right;
}
.table-head-cell--withActions {
  padding-right: 17px;
}
.table-head-cell--virtualized {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/table/TableHeadCell.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;EACA,oBAAA;AASF;AAPE;EACE,gBAAA;AASJ;AANE;EACE,kBAAA;AAQJ;AALE;EACE,iBAAA;AAOJ;AAJE;EACE,mBAAA;AAMJ;AAHE;EACE,aAAA;AAKJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.table-head-cell {\n  position: relative;\n  vertical-align: bottom;\n  font-weight: @fontWeight-semibold;\n  font-family: @IBMPlexSans;\n  line-height: inherit;\n\n  &--align-left {\n    text-align: left;\n  }\n\n  &--align-center {\n    text-align: center;\n  }\n\n  &--align-right {\n    text-align: right;\n  }\n\n  &--withActions {\n    padding-right: 17px;\n  }\n\n  &--virtualized {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
